<template>
  <div class="tw-max-h-[90vh]">
    <PageHeader>
      <template #header-title>
        {{ $t('Job posts') }}
      </template>
      <template #header-actions>
        <WdsStack class="tw-mb-2" direction-row gap-md align-center>
          <WdsButton href="/hire" primary>
            {{ $t('New job post') }}
          </WdsButton>
        </WdsStack>
      </template>
    </PageHeader>

    <JobsGraphqlTable />
  </div>
</template>

<script lang="ts" setup>
import { WdsButton, WdsStack } from '@worksome/wds-components'
import PageHeader from '@/components/PageHeader.vue'
import { $t } from '@/composables/translation'
import JobsGraphqlTable from '@/components/Job/Table/JobsGraphqlTable.vue'
</script>

<style lang="scss" scoped></style>
